<script setup lang="ts">
const {
  onClickStories,
  hasStories = false,
  hasUnseenStories = false,
} = defineProps<{
  onClickStories?: () => void;
  hasStories: boolean;
  hasUnseenStories?: boolean;
}>();

const handleClickStories = () => {
  if (onClickStories && hasStories) onClickStories();
};

// opcional: quem precisa reagir ao clique na logo além da navegação padrão
// (ex.: fechar um modal/painel que esteja aberto por cima) escuta este emit —
// a navegação pra "/" continua sendo o NuxtLink normal, isto é só um extra.
const emit = defineEmits<{ 'click-logo': [] }>();
</script>

<template>
  <div class="flex items-center gap-1 sm:gap-3">
    <button
      class="flex shrink-0 rounded-full w-10 h-10 sm:w-12 sm:h-12 items-center justify-center relative p-[2px]"
      :class="
        hasStories && hasUnseenStories
          ? 'bg-gradient-to-b from-[#7024C4] via-[#C21975] via-[#C74C4D] to-[#E09B3D] story-pulse'
          : 'bg-white/50'
      "
      @click="handleClickStories"
    >
      <span
        class="flex rounded-full w-full h-full items-center justify-center bg-[#0606AD]"
      >
        <ApLogoIcon class="w-full h-full" />
      </span>
    </button>

    <NuxtLink
      :aria-label="`${appName()}`"
      class="flex"
      :draggable="false"
      no-prefetch
      :to="localeLink('/')"
      @click="emit('click-logo')"
    >
      <ApLogoText class="w-full h-full max-h-[12px] md:max-h-[14px]" />
    </NuxtLink>
  </div>
</template>

<style scoped>
@keyframes story-pulse {
  0%,
  100% {
    box-shadow:
      0 0 0 0 rgba(194, 25, 117, 0.7),
      0 0 8px 2px rgba(194, 25, 117, 0.4);
    transform: scale(1);
  }
  50% {
    box-shadow:
      0 0 0 5px rgba(194, 25, 117, 0),
      0 0 18px 6px rgba(194, 25, 117, 0.55);
    transform: scale(1.06);
  }
}

.story-pulse {
  animation: story-pulse 2s ease-in-out infinite;
}
</style>
